import { AxiosRequestConfig } from 'axios'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { Delete } from './Delete'
import {
  CreateServicePrincipalDto,
  GetServicePrincipalsParams,
  UpdateServicePrincipalDto,
} from './ServicePrincipal.interface'
import { ApiHelpers, APIHosts } from './ApiHelpers'

class ServicePrincipalServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  private get url() {
    return `${this.getHost(this.ApiHost)}/service-principals`
  }

  public Get = {
    // `params.organizationId` scopes the query to one Organization. The API
    // returns 403 for any caller without the System role when it is missing,
    // so callers must always pass the current Organization's guid.
    getServicePrincipals: (
      params: GetServicePrincipalsParams = {},
      options: AxiosRequestConfig = {},
    ) => {
      return Get(this.url, {
        ...options,
        params: { ...params, ...options.params },
      })
    },
    getServicePrincipalById: (id: string, options: AxiosRequestConfig = {}) => {
      return Get(`${this.url}/${id}`, options)
    },
    // SP_Claims — the ProductClaims reachable through all Roles assigned to
    // this Service Principal, scoped to `audience` (a Product's `clientId`).
    getClaims: (
      id: string,
      audience: string,
      options: AxiosRequestConfig = {},
    ) => {
      return Get(`${this.url}/${id}/claims`, { ...options, params: { audience, ...options.params } })
    },
  }

  public Post = {
    createServicePrincipal: (
      data: CreateServicePrincipalDto,
      options: AxiosRequestConfig = {},
    ) => {
      return Post(this.url, data, options)
    },
    assignRole: (
      servicePrincipalId: string,
      roleId: string,
      options: AxiosRequestConfig = {},
    ) => {
      return Post(`${this.url}/${servicePrincipalId}/roles`, { roleId }, options)
    },
  }

  public Put = {
    updateServicePrincipal: (
      id: string,
      data: UpdateServicePrincipalDto,
      options: AxiosRequestConfig = {},
    ) => {
      return Put(`${this.url}/${id}`, data, options)
    },
  }

  public Delete = {
    deleteServicePrincipal: (id: string, options: AxiosRequestConfig = {}) => {
      return Delete(`${this.url}/${id}`, {}, options)
    },
    removeRole: (
      servicePrincipalId: string,
      roleId: string,
      options: AxiosRequestConfig = {},
    ) => {
      return Delete(`${this.url}/${servicePrincipalId}/roles/${roleId}`, {}, options)
    },
  }
}

export const ServicePrincipalService = new ServicePrincipalServiceController()
